<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
      <a [routerLink]="['/process']">Library Process</a>
    </li>
    <li>
      <span>{{PageTitle}}</span>
    </li>
  </ul>
  
     
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="myModalLabel"></strong>
      </span>
   
      <button type="button" class="btn btn-sm btn-default pull-right btn-back"  (click)="back()">
        <i class="fa fa-chevron-circle-left"></i>&nbsp;Back
      </button>
  
    </div> 
    <div class="card-block">
      <div class="row">
        <div class="col-md-12">
          <form [formGroup]="processMasterForm" class="well">
            <div class="row">
  
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-control-label">Global / Company</label>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="md-radio md-radio-inline" style="display: inline-block">
                            <input id="IsGlobalYes" type="radio" [formControl]="processMasterForm.controls['IsGlobal']" style="position:absolute" name="IsGlobal"
                              value="Global" class="form-check-input" (click)="changeIsGlobal('Global')">
                            <label for="IsGlobalYes" style="padding: 0 29px 0px 0px">Global</label>
                          </div>
                          <div class="md-radio md-radio-inline" style="display: inline-block">
                            <input id="IsGlobalNo" type="radio" [formControl]="processMasterForm.controls['IsGlobal']" style="position:absolute" name="IsGlobal"
                              value="Company" class="form-check-input" (click)="changeIsGlobal('Company')">
                            <label for="IsGlobalNo">Company</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-3">
                        <label class="form-control-label" for="l0">Process Name
                          <span _ngcontent-c2="" style="color: red;">*</span>
                        </label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <input [formControl]="processMasterForm.controls['ProcessName']" class="form-control" id="processName" required>
                          <!-- <div *ngIf="processMasterForm.controls['ProcessName'].hasError('required') && processMasterForm.controls['ProcessName'].touched"
                            class="form-control-error-custom">
                            Process name is required.
                          </div> -->
  
                          <div *ngIf="(processMasterForm.controls['ProcessName'].hasError('required') && processMasterForm.controls['ProcessName'].hasError('whitespace') &&  processMasterForm.controls['ProcessName'].touched) || (processMasterForm.controls['ProcessName'].hasError('required') && processMasterForm.controls['ProcessName'].touched)"
                          class="form-control-error-custom">
                          Process name is required.
                        </div>
  
                        
                          <!-- <div *ngIf="processMasterForm.controls['ProcessName'].hasError('pattern') && processMasterForm.controls['ProcessName'].touched"
                            class="form-control-error-custom">
                            Please enter a valid Process name.
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <!-- <div class="col-md-12">
                          <div class="row"> -->
                      <div class="col-md-1">
                        <div class="form-group">
                          <div class="md-checkbox">
                            <!--<input type="checkbox" id="1" [ngModel]="filter" (ngModelChange)="onFilterChange($event)">-->
                            <input id="IsMeetingSpecific" #meetingSpecific type="checkbox" [(ngModel)]="isMeetingTask" [ngModelOptions]="{standalone: true}"
                              (change)="0" checked [disabled]="!hasPermission">
                            <label for="IsMeetingSpecific"></label>
                          </div>
  
  
                        </div>
                      </div>
                      <div class="col-md-11">
                        <div class="form-group" style="padding-top: 0px;">
                          <label class="form-control-label">Select in case of Meeting Specific Process (if not selected then this process will not be shown in
                            meeting add screen)</label>
                        </div>
                      </div>
  
                      <!-- </div>
                        </div> -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row" *ngIf="meetingSpecific.checked">
                      <!-- <div class="col-md-12"> -->
                      <div class="col-md-3">
                        <label class="form-control-label" for="l0">Meeting Type
                          <span _ngcontent-c2="" style="color: red;">*</span>
                        </label>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <select *ngIf="!disableOnEdit" [formControl]="processMasterForm.controls['meetingtypeId']" class="form-control select" [(ngModel)]="meetingtypeIdmodel">
                            <option value="0"> None </option>
                            <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                              {{meetingType.MeetingType}}
                            </option>
                          </select>
                          <input id="meetingTypeName" *ngIf="disableOnEdit" type="text" class="form-control">
                          <input id="meetingTypeIdWhileEdit" *ngIf="disableOnEdit" type="hidden" class="form-control">
                          <div *ngIf='meetingSpecific.checked && meetingtypeIdmodel=="0"' class="form-control-error-custom">
                            Meeting Type is required.
                          </div>
  
                        </div>
                      </div>
                      <!-- <input type="hidden" id="dataaddedforprocess" [(ngModel)]="dataAdd"> -->
                      <!-- </div> -->
                    </div>
                  </div>
  
                </div>
  
                <div class="col-md-12">
                  <section class="panel panel-default">
                    <div class="panel-heading">
                      <h5 class="panel-title pull-left">Tasks</h5>
                      <div class="pull-right">
                        <button type="button" (click)="regiserModalShowEvent()" class="btn-sm btn btn-primary" data-target="#AddCompliancesDialog"
                          [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                          <i class="fa fa-plus"></i>&nbsp;Add Task to Process
                        </button>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <div class="panel-body" style="padding: 10px 0;">
                      <div class="col-md-12" style="padding: 0">
                        <table datatable [dtOptions]="dtOptionsForAddedTask" [dtTrigger]="dtTriggerForAddedTask" class="table table-hover compact cell-border nowrap stripe"
                            id="addedtaskTable" style="cursor: pointer;">
                            <thead>
                              <tr>
                                <!-- <th>Order </th> -->
                                <th>Task Name </th>
                                <th>Task Description </th>
                                <th>Tag</th>
                                <th>Remove</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let processtask of predefinedCompanyTaskList; let count=index">
  
                                <!-- <td tabindex="1">{{processtask.Order }}</td> -->
                                <td tabindex="1" style="white-space: normal !important;"> <span style="display: none">{{(processtask.Order)+1000}}_</span> {{processtask.TaskName }}</td>
                                <td tabindex="2" style="white-space: normal !important;">{{processtask.TaskDescription }}</td>
                                <td tabindex="3" style="white-space: normal !important;">{{processtask.GroupName }}</td>
                                <td tabindex="4">
                                  <button *ngIf="(processtask._id==null || processtask._id==undefined)" type="button" class="btn-sm btn btn-danger" (click)="removeTaskFromList(processtask.Task_id)"
                                  [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                                  <span class="fa fa-close"></span>
                                </button>
                                <button *ngIf="(processtask._id!=null || processtask._id!=undefined)" type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(processtask._id,processtask.IsGlobal)"
                                  [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                                  <span class="icmn-bin"></span>
                                </button>&nbsp;&nbsp;
                                <button *ngIf="(processtask._id!=null || processtask._id!=undefined)" type="button" class="btn-sm btn btn-warning" (click)="EditTask(processtask.ID)" 
                                [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                                </td>
                              </tr>
                            </tbody>
                        </table>
  
                        <!--  Newly added for rearrage-->
                        <!-- <table  datatable [dtOptions]="dtOptionsForAddedTask" id="addedtaskTable" class="table table-hover compact cell-border nowrap stripe">
                          <thead>
                            <tr>
                                <th>OrderID </th>
                                <th>Task Name </th>
                                <th>Task Description </th>
                                <th>Tag</th>
                                <th>Remove</th> 
                            </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let processtask of predefinedCompanyTaskList; let count=index">
  
                                <td tabindex="1">{{processtask.OrderID }}</td>
                                <td tabindex="2">{{processtask.TaskName }}</td>
                                <td tabindex="3">{{processtask.TaskDescription }}</td>
                                <td tabindex="4">{{processtask.GroupName }}</td>
                                <td tabindex="5">
                                  <button *ngIf="(processtask._id==null || processtask._id==undefined)" type="button" class="btn-sm btn btn-danger" (click)="removeTaskFromList(processtask.Task_id)"
                                  [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                                  <span class="fa fa-close"></span>
                                </button>
                                <button *ngIf="(processtask._id!=null || processtask._id!=undefined)" type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(processtask._id)"
                                  [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                                  <span class="icmn-bin"></span>
                                </button>&nbsp;&nbsp;
                                <button *ngIf="(processtask._id!=null || processtask._id!=undefined)" type="button" class="btn-sm btn btn-warning" (click)="EditTask(processtask.ID)" 
                                [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                                </td>
                              </tr>
                              <tr *ngIf="predefinedCompanyTaskList?.length == 0">
                                  <td colspan="3" class="no-data-available">No data!</td>
                              </tr>
                            </tbody>
                        </table>  -->
  
  
  
                      </div>
                    </div>
                  </section>
                </div>
  
              </div>
              <div class="col-md-12">
                <div class="form-actions" style="text-align: right">
                    <button type="button" id="buttonsaveOrder" class="btn btn-sm btn-primary" data-dismiss="modal" [disabled]="!processMasterForm.valid || disabledOnclick" (click)="processTasksSaveOrder()">
                        Save Order</button>
  
                  <button id="btnsaveProcess" type="button" class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || disabledOnclick || meetingSpecific.checked && meetingtypeIdmodel=="0"'
                    (click)="addProcess()" [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                    <i class="fa fa-save"></i>&nbsp;Save</button>
                  <button id="btnupdateProcess" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || disabledOnclick || meetingSpecific.checked && meetingtypeIdmodel=="0"'
                    (click)="editProcess()" [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                    <i class="fa fa-save"></i>&nbsp;Update</button>
  
                  <button id="btnshowtaskparticulars" type="button" data-target="#taskParticularsDialog" class="btn btn-sm btn-primary" (click)="showTaskParticularsDialogue()"
                    [disabled]='!processMasterForm.valid || disabledOnclick || (meetingSpecific.checked && meetingtypeIdmodel=="0") || (!dataAdd)'
                    [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                    <i class="fa fa-save"></i>&nbsp;Save & Activate</button>
  
                  <button id="btnshowtaskparticularsforupdateandactivate" type="button" data-target="#taskParticularsDialog" (click)="showTaskParticularsDialogue()"
                    class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || disabledOnclick || (meetingSpecific.checked && meetingtypeIdmodel=="0") || (!taskaddedforactivateProcess)'
                    [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                    <i class="fa fa-save"></i>&nbsp;Update & Activate</button>
  
                  <button type="buttonreset" id="buttonreset" class="btn btn-sm" data-dismiss="modal" (click)="reset()" [appHasPermission]="{'Url': '/process/edit?goveva=true&email=', 'method':'put', 'menu': 'Process'}">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
  
                   
  
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  
  
  
  
    <div class="modal fade" id="resetConfirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDelete">
              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to reset the form data?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="resetFormData()">
              <i class="fa fa-check"></i>&nbsp;Yes</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;No</button>
          </div>
        </div>
      </div>
    </div>
  
  
    <div class="modal fade modal-size-medium" id="taskParticularsDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog">
        <form [formGroup]="processMasterForm" class="well">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myModalLabel">Task Particulars</h5>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="removeTaskParticularsvalidation()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-3">
                  <label class="form-control-label" for="l0">Task Particulars
                    <span _ngcontent-c2="" style="color: red;">*</span>
                  </label>
                </div>
                <div class="col-md-9">
                  <div class="form-group">
  
                    <input [formControl]="processMasterForm.controls['TaskParticulars']" class="form-control" [(ngModel)]="taskParticularsmodel">
                    <div *ngIf="processMasterForm.controls['TaskParticulars'].hasError('required') && (processMasterForm.controls['TaskParticulars'].dirty)"
                      class="form-control-error-custom">
                      Task Particulars Name is required.
                    </div>
                    <!-- <div *ngIf="(taskParticularsmodel=== undefined)" class="form-control-error-custom">
                        Task Particulars Name is required.
                     </div>  -->
                    <!-- <div *ngIf="taskForm.controls['TaskParticulars'].hasError('pattern') && taskForm.controls['TaskParticulars'].touched" class="form-control-error-custom">
                       Please enter  valid Task Particulars Name.
                    </div> -->
                  </div>
                </div>
  
              </div>
  
            </div>
            <div class="modal-footer">
  
              <button id="btnsaveandActivateTask" type="button" class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || disabledOnclick || (taskParticularsmodel=== undefined)'
                (click)="saveandactivateProcess()">
                <i class="fa fa-save"></i>&nbsp;Save and Activate</button>
  
              <button id="btnupdateandActivateTask" type="button" class="btn btn-sm btn-primary" [disabled]='!processMasterForm.valid || disabledOnclick || (taskParticularsmodel=== undefined)'
                (click)="updateandactivateProcess()">
                <i class="fa fa-save"></i>&nbsp;Update and Activate</button>
  
              <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="removeTaskParticularsvalidation()">
                <i class="fa fa-times"></i>&nbsp;Close</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  
  
    <div class="modal fade modal-size-large" id="AddCompliancesDialog" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static"
      aria-labelledby="" aria-hidden="true">
      <div class="modal-dialog" role="document">
  
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="taskLabel">
              <i class="fa fa-plus"></i>&nbsp; Add Tasks to Process</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body modal-body-Compliances">
  
            <section class="card search-box">
              <div class="card-block">
  
                <div class="row">
                  <div class="col-md-3">
                    <label>User defined / Predefined</label>
                  </div>
  
  
                  <div class="col-md-3">
                    <div class="form-group">
                      <label> Tag</label>
                    </div>
                  </div>
                  <!-- <div class="col-md-3">
                        <label>  Event Based / Periodic</label>
                      </div> -->
                  <div class="col-md-3">
  
                  </div>
  
                </div>
  
                <div class="row">
                  <div class="col-md-3">
                    <div class="input-group">
                      <!-- <label>Search By UserDefined/Predefined</label> -->
                      <div class="md-radio md-radio-inline">
                        <input id="IsPredefinedYes" type="radio" style="position:absolute" name="TaskuserdefinedorPredefined" [(ngModel)]="SearchtaskUserdefinedorPredefinedModel"
                          value='true' class="form-check-input">
                        <label for="IsPredefinedYes" style="padding: 0 29px 0px 0px">Pre-Defined</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsPredefinedNo" type="radio" style="position:absolute" name=" TaskuserdefinedorPredefined" [(ngModel)]="SearchtaskUserdefinedorPredefinedModel"
                          value='false' class="form-check-input">
                        <label for="IsPredefinedNo">User Defined</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <select id="groupdropdown" class="form-control select" (change)="getSelectedGroupID($event)">
                        <option value="null">Select</option>
                        <option *ngFor="let group of groupTypes" value={{group._id}}>
                          {{group.GroupName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-md-3">
                     
                        <div class="md-radio md-radio-inline">
                          <input id="IsEventBased" type="radio" style="position:absolute" name="TaskEventbasedorPeriodic" [(ngModel)]="SearchtaskEventbasedorPeriodicModel"
                            value='1' class="form-check-input">
                          <label for="IsEventBased">Event Based</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsPeriodic" type="radio" style="position:absolute" name=" TaskEventbasedorPeriodic" [(ngModel)]="SearchtaskEventbasedorPeriodicModel"
                            value='2' class="form-check-input">
                          <label for="IsPeriodic">Periodic</label>
                        </div>
                      </div> -->
  
                  <div class="col-md-3">
                    <div class=" text-right">
                      <button id="btnSearch" class="btn btn-primary btn-sm center-block" (click)="showTasksBySearchData()" Style="width: 100px;">
                        <i class="fa fa-search"></i>&nbsp;Search</button>&nbsp;&nbsp;
                      <button id="btnClear" class="btn btn-default btn-sm center-block" (click)="refreshTaskList()" Style="width: 100px;">
                        <i class="fa fa-refresh"></i>&nbsp;Clear</button>
  
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div class="row">
              <div class="col-md-12">
                <div class="margin-bottom-50">
                  <div class="table-responsive">
  
                    <table datatable [dtOptions]="dtOptionsTaskAddingPopup" [dtTrigger]="dtTriggerTaskAddingPopup" class="table table-hover compact cell-border nowrap stripe"
                      id="companytaskTable" style="cursor: pointer; width: max-content">
                      <!-- style="width:3500px" -->
                      <thead>
                        <tr>
                            <th style="display:none">Task ID</th>
                          <th tabindex="1">
                            <div class="md-checkbox">
                              <input id="selectcheckboxall" class="md-checkbox" type="checkbox" [(ngModel)]="selectedAll" (change)="checkAllIfselectAll();"
                              />
                              <label for="selectcheckboxall">&nbsp;</label>
                            </div>
                          </th>
                          <th tabindex="1">Task Name </th>
                          <th tabindex="1">Task Description </th>
  
                          <th tabindex="1">Tag</th>
  
  
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let companytask of companytasklist; let count=index">
                            <td tabindex="1" style="display: none">{{companytask.ID}}</td>                          
                          <td>
                            <div class="md-checkbox">
                              <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="companytask.SelectedTasks" (change)="checkIfAllSelected();"
                                (change)="checkselected($event);">
                              <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                            </div>
                          </td>
  
                          <td tabindex="1" style="white-space: normal !important;">{{companytask.TaskName }}</td>
                          <td tabindex="2" style="white-space: normal !important;">{{companytask.TaskDescription }}</td>
                          <td tabindex="3">{{companytask.GroupName }}</td>
  
                        </tr>
                      </tbody>
  
                    </table>
  
                  </div>
  
                </div>
              </div>
            </div>
  
          </div>
          <div class="modal-footer">
            <button id="btnaddtask" type="button" class="btn-sm btn btn-primary"  [disabled]="disabledOnclick" (click)="addTasksToProcess()">
              <i class="fa fa-check"></i>&nbsp;Add Selected Task</button>
  
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;Cancel</button>
          </div>
        </div>
  
      </div>
    </div>
  
    <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDelete">
              <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to delete this task?<br>
                <span *ngIf='isTaskGlobal'>On deletion it will be deleted from all the companies.</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger" (click)="deleteTaskProcess()">
              <i class="fa fa-check"></i>&nbsp;Yes</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;No</button>
          </div>
        </div>
      </div>
    </div>
  
    <div class="modal fade" id="warningModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa fa-question-circle-o mr-2"></i>Warning</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Task cannot be deleted as it is already selected in Process by one Company.
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>&nbsp;Close</button>
          </div>
        </div>
      </div>
    </div>  
  

  </section>
  <app-alert></app-alert>